import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "iconType", "variant", "unicode"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
/**
 *
 * Icon
 *
 */

import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@fil-react-components/with-styles';
import styles from './Icon.style';
var Icon = function Icon(_ref) {
  var _context;
  var className = _ref.className,
    iconType = _ref.iconType,
    variant = _ref.variant,
    unicode = _ref.unicode,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classnames('icon', 'fil-icon', className, variant ? _concatInstanceProperty(_context = "fil-icon-".concat(iconType, "-")).call(_context, variant) : "fil-icon-".concat(iconType))
  }, otherProps), /*#__PURE__*/React.createElement("span", {
    className: "show-for-sr"
  }, iconType));
};

/* istanbul ignore next */
Icon.defaultProps = {
  iconType: 'search',
  variant: null,
  className: '',
  unicode: null
};
Icon.displayName = 'Icon';
Icon.propTypes = {
  iconType: PropTypes.string,
  variant: PropTypes.oneOf(['bold', 'regular', 'light', 'circle', 'small', '14', 's', 'm', '', 'r', 'd', 'link']),
  className: PropTypes.string,
  unicode: PropTypes.string
};
export default withStyles(Icon, styles);